import React from 'react';

function CheckIcon(props) {
  return (
    <svg viewBox="0 0 24 24" width={24} {...props}>
      <polygon points="19.59 4.18 9 14.76 4.83 10.59 1.99 13.41 9 20.41 22.41 7 19.59 4.18" />
    </svg>
  );
}

export default CheckIcon;



// WEBPACK FOOTER //
// ./src/site-render/src/icons/CheckIcon.js